interface Colors {
  /* 기존 키 — 남아 있는 컴포넌트 호환용 */
  primary: string;
  secondary: string;
  third: string;
  white: string;
  gray: string;
  black: string;
  lightGray: string;
  darkGray: string;

  /* --- 브랜드 토큰 --- */
  /** 본문 글자색 */
  ink: string;
  /** 페이지 배경 */
  bg: string;
  /** 카드 · 입력창 배경 */
  surface: string;
  /** 입력창 등 살짝 눌린 배경 */
  surfaceAlt: string;
  /** 섹션 구분용 옅은 배경 */
  tint: string;
  /** 테두리 · 구분선 */
  line: string;
  /** 테두리 호버 */
  lineHover: string;
  /** 보조 텍스트 */
  muted: string;
  /** 가장 흐린 텍스트 (날짜 등) */
  faint: string;
  /** 강조 컬러 (링크 · 라벨 등 텍스트) */
  brand: string;
  /** 강조 버튼 배경 */
  brandBtn: string;
  /** 강조 버튼 배경 호버 */
  brandDark: string;
  /** 강조 컬러의 옅은 배경 */
  brandSoft: string;
  /** 어두운 면 (하단 CTA 밴드, 조직도 최상단, 모바일 메뉴 오버레이) */
  deep: string;
  /** deep 위의 글자색 */
  onDeep: string;
  /** deep 위의 보조 글자색 */
  onDeepMuted: string;
}

type MediaQuery = {
  mobile: string;
};

type Fonts = {
  mono: string;
};

export type AppTheme = {
  colors: Colors;
  mediaQuery: MediaQuery;
  fonts: Fonts;
};

const mediaQuery: MediaQuery = {
  mobile: 'screen and (min-width: 375px) and (max-width: 1000px)',
};

const fonts: Fonts = {
  mono: "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
};

const colors: Colors = {
  primary: '#263140',
  secondary: '#5b7a8c',
  third: '#f2e9d8',
  white: '#ffffff',
  gray: '#c9c9c9b8',
  black: '#000000',
  lightGray: '#7a7a7a',
  darkGray: '#575757',

  ink: '#071324',
  bg: '#ffffff',
  surface: '#ffffff',
  surfaceAlt: '#fbfcfe',
  tint: '#edf2fc',
  line: '#dce4f2',
  lineHover: '#c6d4ee',
  muted: '#5a6b85',
  faint: '#94a3bc',
  brand: '#1a56db',
  brandBtn: '#1a56db',
  brandDark: '#1449ba',
  brandSoft: '#dfe8fa',
  deep: '#071324',
  onDeep: '#ffffff',
  onDeepMuted: '#9fb2ce',
};

const theme: AppTheme = { colors, mediaQuery, fonts };

export default theme;
